class User {
  constructor() {
    this.reference = "";
    this.firstName = "";
    this.lastName = "";
    this.phoneNumber = "";
    this.email = "";
    this.isActive = false;
    this.profilePictureUrl = "";
    this.metaData = {};
  }

  setReference(reference) {
    this.reference = reference;
    return this;
  }

  getReference() {
    return this.reference;
  }

  setFirstName(firstName) {
    this.firstName = firstName;
    return this;
  }

  getFirstName() {
    return this.firstName;
  }

  setLastName(lastName) {
    this.lastName = lastName;
    return this;
  }

  getLastName() {
    return this.lastName;
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
    return this;
  }

  getPhoneNumber() {
    return this.phoneNumber;
  }

  setEmail(email) {
    this.email = email;
    return this;
  }

  getEmail() {
    return this.email;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
    return this;
  }

  getIsActive() {
    return this.isActive;
  }

  setProfilePictureUrl(profilePictureUrl) {
    this.profilePictureUrl = profilePictureUrl;
    return this;
  }

  getProfilePictureUrl() {
    return this.profilePictureUrl;
  }

  setMetaData(value, key) {
    if (key) this.metaData[key] = value;
    else this.metaData = value;
    return this;
  }

  getMetaData(key) {
    if (key) return (this.metaData || {})[key];
    return this.metaData;
  }
}

export { User };
